import { render, staticRenderFns } from "./CrudManagementTeamList.vue?vue&type=template&id=ac8ca60e&"
import script from "./CrudManagementTeamList.vue?vue&type=script&lang=js&"
export * from "./CrudManagementTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports